import { createIcon } from '@chakra-ui/react'

export const Square = createIcon({
  displayName: 'Square',
  viewBox: '0 0 14 14',
  d: 'M12.2323 1.76768V12.2323H1.76768V1.76768H12.2323ZM14 0H0V14H14V0Z',
})
